import firebase from 'firebase/app';
import React, { useCallback, useState } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { parse } from 'papaparse';
import { userWithDefault } from '../types/user';
import { CSVLink } from 'react-csv';
import {
  CSVUser,
  CSVUserWithDefault,
  UserToCSVUser,
  CSVUserToUser,
} from '../types/csvUser';
import { Root, H3, Hr, Explanation } from './common/styled';
const isFileList = (target: FileList | null): target is FileList => {
  return target !== null;
};

export const AdminCSV = memoNamed('AdminCSV', () => {
  const [messageList, setMessageList] = useState<string[]>([]);

  const addFirestore = useCallback((arr: CSVUser[]) => {
    const db = firebase.firestore();
    arr.forEach((data) => {
      if (data.sei === '' && data.mei === '') return;
      if (data.identification === '') {
        setMessageList((messageList) => [
          ...messageList,
          `${data.sei}${data.mei}さんのidentificationが設定されていないため、登録できませんでした。`,
        ]);
        return;
      }
      //TODO Identification check(promiseとかかしら？)
      const user = CSVUserToUser(data);
      db.collection('Users')
        .add(user)
        .then(() => {
          setMessageList((messageList) => [
            ...messageList,
            `${data.sei} ${data.mei}さんの登録に成功しました。`,
          ]);
        })
        .catch((error) => {
          console.error(error);
          setMessageList((messageList) => [
            ...messageList,
            `${data.sei} ${data.mei}さんの登録に失敗しました。`,
          ]);
        });
    });
  }, []);

  const readFile = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const _files: FileList | null = event.target.files;
      if (isFileList(_files)) {
        parse(_files[0], {
          header: true,
          complete: (results) => {
            addFirestore(
              results.data.map((u) => CSVUserWithDefault(u as object))
            );
          },
        });
      }
    },
    [addFirestore]
  );

  const [generated, setGenerated] = useState<boolean>(false);
  const [namesData, setNamesData] = useState<CSVUser[]>([]);

  const generateData = useCallback(() => {
    setGenerated(false);
    const db = firebase.firestore();
    db.collection('Users')
      .get()
      .then((snapshot) => {
        setNamesData(
          snapshot.docs.map((doc) => UserToCSVUser(userWithDefault(doc.data())))
        );
        setGenerated(true);
      });
  }, []);

  return (
    <Root>
      <H3>名簿からエクスポート</H3>
      <Hr />
      <button onClick={generateData}>CSVデータを生成</button>
      {generated ? (
        <CSVLink
          data={namesData}
          filename={`${new Date().getFullYear()}_${
            new Date().getMonth() + 1
          }_${new Date().getDate()}_Names.csv`}
        >
          CSVファイルをダウンロード
        </CSVLink>
      ) : undefined}
      <Explanation>
        名簿をCSVデータにエクスポートします。定期的にこの操作を行い、内容をバックアップとしてローカルやクラウドに保管してください。ただし、取り扱いには注意してください。流出してしまうことの無いよう、細心の注意を払ってください。郵送書類作成用にエクスポートする場合は、最後の4列に郵送先の情報を載せたoutputデータが出力されるので、活用してください。
      </Explanation>
      <br />
      <H3>名簿にインポート</H3>
      <Hr />
      ファイルを選択
      <input type='file' onChange={readFile} />
      {messageList.map((u, i) => (
        <div key={i}>
          {u}
          <br />
        </div>
      ))}
      <br />
      <Explanation>
        注意:CSVファイルにおいて、identificationの列の各行は重複しない6文字の半角英字を設定してください。CSVデータは名簿には上書きされず、追加されます。CSVファイルはエクスポートして得られるCSVファイルと同様の形式で用意してください。
      </Explanation>
    </Root>
  );
});
